import request from '@/utils/request'

// 查询背景音乐列表
export function listMusic(query) {
  return request({
    url: '/comm/music/list',
    method: 'get',
    params: query
  })
}

// 查询背景音乐分页
export function pageMusic(query) {
  return request({
    url: '/comm/music/page',
    method: 'get',
    params: query
  })
}

// 查询背景音乐详细
export function getMusic(data) {
  return request({
    url: '/comm/music/detail',
    method: 'get',
    params: data
  })
}

// 新增背景音乐
export function addMusic(data) {
  return request({
    url: '/comm/music/add',
    method: 'post',
    data: data
  })
}

// 修改背景音乐
export function updateMusic(data) {
  return request({
    url: '/comm/music/edit',
    method: 'post',
    data: data
  })
}

// 删除背景音乐
export function delMusic(data) {
  return request({
    url: '/comm/music/delete',
    method: 'post',
    data: data
  })
}
